import feathersClient from '@/api-client'

const authManagement = feathersClient.service('authManagement')

export function requestPasswordReset (identifier) {
  const value = identifier.trim()
  const identity = value.includes('@')
    ? { email: value.toLowerCase() }
    : { username: value }

  return authManagement.create({ action: 'sendResetPwd', value: identity })
}

export function resetPassword (token, password) {
  return authManagement.create({ action: 'resetPwdLong', value: { token, password } })
}
